import WidgetRevenueConfiguration from './widgetRevenue/configuration/WidgetRevenueConfiguration';
import ExpandedMobileWidgetRevenue from './widgetRevenue/mobileWidgetRevenue/ExpandedMobileWidgetRevenue';
import WidgetRevenue from './widgetRevenue/WidgetRevenue';
import { ModuleCodeEnum, WidgetTemplateType } from '../../../types/widget';
import { WidgetEnum } from '../../../utils/widgets';

const widgets: WidgetTemplateType[] = [
	{
		component: WidgetRevenue,
		expandedComponent: ExpandedMobileWidgetRevenue,
		configurationComponent: WidgetRevenueConfiguration,
		name: 'Graphique',
		type: WidgetEnum.CHART,
		minW: 2,
		maxW: Infinity,
		minH: 2,
		maxH: Infinity,
		moduleCode: ModuleCodeEnum.ACCOUNTING,
		isAvailableOnDesktopFormat: true,
		isAvailableOnMobileFormat: true,
	},
];

export default widgets;
